import { c as setMode } from './index-82a6d1fa.js';

// Used by Stencil to identify the brand attribute
const appGlobalScript = () => {
  const brandResolver = (elm) => {
    if (isDatePickerInput(elm)) {
      // The groupui-input in the date picker does not seem to receive the correct brand property before the brand resolver is called.
      // To work around this, we look for the .flatpickr.input-wrapper instance that belongs to the groupui-input and return the brand from that element.
      const flatpickrBrand = getBrandFromFlatpickrInputWrapper(elm);
      if (flatpickrBrand)
        return flatpickrBrand;
    }
    const brand = elm.brand || elm.getAttribute('brand');
    if (brand) {
      return brand;
    }
    else if (!elm.parentElement) {
      return 'vwgroup';
    }
    else {
      return brandResolver(elm.parentElement);
    }
  };
  setMode((elm) => {
    return brandResolver(elm);
  });
};
const isDatePickerInput = (elm) => elm.tagName === 'GROUPUI-INPUT' && elm.className.includes('date-picker-input');
const getBrandFromFlatpickrInputWrapper = (elm) => {
  let brand;
  // get all date pickers in the document and find the one that belongs to the groupui-input
  const datePickers = document.querySelectorAll('groupui-date-picker');
  datePickers.forEach((datePicker) => {
    var _a, _b;
    const flatpickr = datePicker.shadowRoot.querySelector('.flatpickr.input-wrapper');
    // flatpickr places the groupui-input next to the input wrapper
    if ((flatpickr === null || flatpickr === void 0 ? void 0 : flatpickr.nextElementSibling) === elm) {
      brand = (_b = (_a = flatpickr.attributes) === null || _a === void 0 ? void 0 : _a.getNamedItem('brand')) === null || _b === void 0 ? void 0 : _b.value;
    }
  });
  return brand;
};

const globalScripts = appGlobalScript;

export { globalScripts as g };

